import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    LEAVE_TEAM: undefined,
    API: {
      LEAVE_TEAM: apiResourceActionCreator('roleAssignments')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.LeaveTeam), authToken, {}, actions.user.api.leaveTeam)

export function* leaveTeam() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'leaveTeam',
  action: actions,
  sagas: leaveTeam,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        ...state.currentUser,
        roleAssignments: action.payload.roleAssignments,
        teamMemberRoles: action.payload.teamMemberRoles
      },
      error: null,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/leaveTeam.js